<template functional>
  <div>
    <icon-view
      class="mb-3"
      icon="fa fa-file-alt"
      icon-background="#FF7058"
      icon-color="#fff"
      title="Información de Estatus Voucher y Pago"
    />
    <div class="row">
      <div class="col ml-2">
        <div class="color-gray-6 font-14 font-weight-normal">
          Payment Count:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.paymentCount }}
        </div>
      </div>
      <div class="col">
        <div class="color-gray-6 font-14 font-weight-normal">
          Payment ID:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.paymentId | empty }}
        </div>
      </div>
      <div class="col">
        <div class="color-gray-6 font-14 font-weight-normal">
          Budget Check Status:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.budgetCheckStatus | empty }}
        </div>
      </div>
      <div class="col">
        <div class="color-gray-6 font-14 font-weight-normal">
          Payment Status:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.paymentStatus | empty }}
        </div>
      </div>
      <div class="col">
        <div class="color-gray-6 font-14 font-weight-normal">
          Payment Process Date:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.paymentProcessDate | date | empty }}
        </div>
      </div>
      <div class="col">
        <div class="color-gray-6 font-14 font-weight-normal">
          Cash Cleared Date:
        </div>
        <div class="color-black font-16 font-weight-normal">
          {{ props.info.cashClearedDate | date | empty }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
export default {
  name: 'VoucherAndPaymentStatusInfo',
  components: {
    IconView,
  },
};
</script>
